<template>
  <div class="animated fadeIn">
    <global-table :table-data="history" :loading="loading" :per-page="500" :bordered="true" :table-detail="tableDetail"
      :hover="true" :striped="false" :fields="fields" :id-modals="'productHistory'" :row-edit="productsHistoryForm"
      :redirect-detail="false" :show-add-button="true" :edit-button="false" :filter-table-only="true"
      caption="<i class='fa fa-align-justify'></i> Produk Listing" addButton="Tambah Produk" @reset="resetForm"
      @editForm="editForm"></global-table>

    <b-modal ref="productHistory" id="productHistory" header-border-variant="no-border text-center"
      footer-border-variant="no-border" footer-bg-variant="light" :no-close-on-backdrop="true" :no-close-on-esc="true"
      hide-footer size="xl">
      <div slot="modal-header" class="text-center">
        <h3 class="text-center" v-if="!isEdit">Tambah Produk</h3>
        <h3 class="text-center" v-else>Ubah Stock {{ productsHistoryForm.product_name }}</h3>
      </div>

      <div v-if="!loadingSubmit">
        <b-form id="productsHistoryForm" validated novalidate @submit="saveProductHistory">
          <template v-if="!isEdit">
            <b-row>
              <b-col sm="4">
                <b-form-group label-for="name" label="Tipe Input">
                  <model-select id="flag" :options="listFlag" v-model="$v.productsHistoryForm.flag.$model"
                    :isError="$v.productsHistoryForm.flag.$invalid" placeholder="-- Harap pilih salah satu --"
                    @input="resetData($event)" required></model-select>
                  <div v-if="productsHistoryForm.flag === null" class="invalid-feedback-custom">Tipe harus di pilih.
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="4" v-if="productsHistoryForm.flag !== '4'">
                <b-form-group label-for="name" label="Jenis Penyesuaian">
                  <model-select id="flag_category" :options="listFlagCategory"
                    v-model="$v.productsHistoryForm.flag_category.$model"
                    :isError="$v.productsHistoryForm.flag_category.$invalid" placeholder="-- Harap pilih salah satu --"
                    required></model-select>
                  <div v-if="productsHistoryForm.flag_category === null" class="invalid-feedback-custom">Jenis
                    penyesuaian harus di
                    pilih.</div>
                </b-form-group>
              </b-col>

              <b-col sm="4">
                <b-form-group label-for="name" label="Produk">
                  <model-select id="product_id" :options="listProducts"
                    v-model="$v.productsHistoryForm.product_id.$model"
                    :isError="$v.productsHistoryForm.product_id.$invalid" placeholder="-- Harap pilih salah satu --"
                    required></model-select>
                  <div v-if="productsHistoryForm.product_id === null" class="invalid-feedback-custom">Produk harus di
                    pilih.</div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <b-form-group label-for="Qty" label="Qty Penambahan Stok">
                  <b-form-input id="qty_in" type="number" v-model="$v.productsHistoryForm.qty_in.$model"
                    :state="!$v.productsHistoryForm.qty_in.$invalid" :min="0" placeholder="Qty"></b-form-input>
                  <b-form-invalid-feedback>Qty harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3" v-if="productsHistoryForm.flag !== '4'">
                <b-form-group label-for="Qty" label="Qty Pengurangan Stok">
                  <b-form-input id="qty_out" type="number" v-model="$v.productsHistoryForm.qty_out.$model"
                    :state="!$v.productsHistoryForm.qty_out.$invalid" :min="0" placeholder="Qty"></b-form-input>
                  <b-form-invalid-feedback>Qty harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="4">
                <b-form-group label-for="date_inserted"
                  :label="(productsHistoryForm.flag == '4') ? 'Tanggal Barang Masuk' : 'Tanggal Penyesuaian'">
                  <v-date-picker id="date_inserted"
                    :input-props="{ class: 'form-control', placeholder: 'Tanggal Barang Masuk', required: '' }"
                    :state="!$v.productsHistoryForm.date_inserted.$invalid"
                    v-model="$v.productsHistoryForm.date_inserted.$model"></v-date-picker>
                  <div v-if="$v.productsHistoryForm.date_inserted.$invalid" class="invalid-feedback-custom">Tanggal
                    Barang Masuk harus di isi.</div>
                </b-form-group>
              </b-col>

              <b-col sm="6">
                <b-form-group label-for="description" label="Deskripsi">
                  <b-form-textarea id="description" :rows="3" :max-rows="6"
                    v-model="$v.productsHistoryForm.description.$model"
                    :state="!$v.productsHistoryForm.description.$invalid"></b-form-textarea>
                  <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </template>

          <!-- <template v-else>
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="past_qty" label="Total Sebelumnya">
                  <b-form-input
                    id="past_qty"
                    type="number"
                    v-model="$v.productsHistoryForm.past_qty.$model"
                    :state="!$v.productsHistoryForm.past_qty.$invalid"
                    required
                    placeholder="Total Sebelumnya"
                  ></b-form-input>
                  <b-form-invalid-feedback>Total Sebelumnya harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="income" label="Barang Masuk">
                  <b-form-input
                    id="income"
                    type="number"
                    v-model="$v.productsHistoryForm.income.$model"
                    :state="!$v.productsHistoryForm.income.$invalid"
                    required
                    placeholder="Barang Masuk"
                  ></b-form-input>
                  <b-form-invalid-feedback>Barang Masuk harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="outcome" label="Barang Keluar">
                  <b-form-input
                    id="outcome"
                    type="number"
                    v-model="$v.productsHistoryForm.outcome.$model"
                    :state="!$v.productsHistoryForm.outcome.$invalid"
                    required
                    placeholder="Barang Keluar"
                  ></b-form-input>
                  <b-form-invalid-feedback>Barang Keluar harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="available" label="Barang Saat Ini">
                  <b-form-input
                    id="available"
                    type="number"
                    v-model="$v.productsHistoryForm.available.$model"
                    :state="!$v.productsHistoryForm.available.$invalid"
                    required
                    placeholder="Barang Saat Ini"
                  ></b-form-input>
                  <b-form-invalid-feedback>Barang Saat Ini harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </template> -->

          <div class="float-right">
            <b-button type="button" size="sm" variant="danger" @click="cancelStockProduct">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
            <b-button type="submit" size="sm" variant="primary" :disabled="$v.productsHistoryForm.$invalid">
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-form>
      </div>

      <div v-else>
        <loading></loading>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "stock-product",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    },
    warehouseId: {
      type: String,
      default: false
    }
  },
  data() {
    return {
      history: [],
      listProducts: [],
      listFlagCategory: [],
      listFlag: [
        { value: '4', text: 'Tambah Produk Ke Gudang' },
        { value: '3', text: 'Penyesuaian Stok' }
      ],
      productsHistoryForm: interfaces.products_history_transaction,
      loadingSubmit: false,
      isEdit: false,
      fields: [
        { key: "product_name", label: "Produk", sortable: true },
        { key: "past_qty", label: "Total Sebelumnya" },
        { key: "income", label: "Barang Masuk" },
        { key: "outcome", label: "Barang Keluar" },
        { key: "available", label: "Total Saat Ini" },
        { key: "date_inserted", label: "Tanggal Masuk Barang" },
        { key: "action", class: "text-center width-80" }
      ],
      loading: false
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations() {
    if (this.productsHistoryForm.flag === '4') {
      return {
        productsHistoryForm: {
          products_history_id: {},
          product_id: { required },
          spkb_number: {},
          order_number: {},
          date_inserted: { required },
          qty_in: { required },
          qty_out: {},
          inserted_by: {},
          adjustment_by: {},
          adjustment_date: {},
          flag: { required },
          flag_category: {},
          description: {}
        }
      };
    } else {
      return {
        productsHistoryForm: {
          products_history_id: {},
          product_id: { required },
          spkb_number: {},
          order_number: {},
          date_inserted: {required },
          qty_in: { required },
          qty_out: { required },
          inserted_by: {},
          adjustment_by: {},
          adjustment_date: {},
          flag: { required },
          flag_category: { required },
          description: {}
        }
      };
    }

  },
  methods: {
    init: function () {
      //this.resetForm();
      this.loading = true;
      this.getData();
      this.getDropdown();
    },
    getData: function () {
      this.axios
        .get("web/warehouse/history/" + this.warehouseId + "/")
        .then(response => {
          this.history = response.data.data;
        })
        .catch(error => { })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function () {
      this.axios
        .get("web/dropdown/warehouse-history-product/")
        .then(response => {
          this.listProducts = response.data.products;
          this.listFlagCategory = response.data.flag_category;
        })
        .catch(error => { })
        .finally(() => {
          this.loading = false;
        });
    },
    resetData: function (data) {
      this.productsHistoryForm.flag_category = null;
      this.productsHistoryForm.product_id = null;
      this.productsHistoryForm.qty_in = null;
      this.productsHistoryForm.qty_out = null;
            this.productsHistoryForm.date_inserted = null;

    },
    editForm: function (editData) {
      this.resetForm();
      this.isEdit = true;
      this.productsHistoryForm = editData;
    },
    resetForm: function () {
      //this.isEdit = false;
      for (var a in interfaces.products_history_transaction) {
        interfaces.products_history_transaction[a] = null;
      }
      this.productsHistoryForm = interfaces.products_history_transaction;
    },
    cancelStockProduct: function () {
      this.isEdit = false;
      this.$refs.productHistory.hide();
      this.resetForm();
    },
    saveProductHistory: function (evt) {
      evt.preventDefault();

      if (this.isEdit) {
        if (confirm("Apakah Anda Yakin Ingin Mengubah Stok ?")) {
          let data = this.productsHistoryForm;
          data.warehouse_id = this.warehouseId;
          data.updated_by = localStorage.getItem("employee_id");
          this.loadingSubmit = true;
          this.axios
            .put("web/warehouse/update-product-history/", data)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Update Stok",
                  message: response.data.message
                });
                this.cancelStockProduct();
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmit = false;
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan stok ?")) {
          let data = this.productsHistoryForm;
          data.warehouse_id = this.warehouseId;
          data.inserted_by = localStorage.getItem("employee_id");
          data.date_inserted = moment(this.productsHistoryForm.date_inserted).format('YYYY-MM-DD');
          this.loadingSubmit = true;
          this.axios
            .post("web/warehouse/add-product-history/", data)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Produk",
                  message: response.data.message
                });
                this.cancelStockProduct();
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmit = false;
              this.init();
            });
        }
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style></style>
